import { render, staticRenderFns } from "./CrmTable.vue?vue&type=template&id=dce13614"
import script from "./CrmTable.vue?vue&type=script&lang=js"
export * from "./CrmTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports